import { render, staticRenderFns } from "./SystemComponentsHierarchyDelete.vue?vue&type=template&id=6b5065f3&"
import script from "./SystemComponentsHierarchyDelete.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports